// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "core.ruffle." + {"482":"3ca69ff41f3f4b829d7f","655":"7c25f7584a670c6525e9"}[chunkId] + ".js";
};